import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import Select from '../../fields/SelectBox';
import { fieldsProps } from './schema';
import { Field } from 'redux-form';
import styles from './styles.scoped.css';
import Button from '../../elements/Button/Button';
import { useSelector } from 'react-redux';
import { Switch } from '@mantine/core';

// import Switch from '../../fields/Switch/Switch';

export default function Component({ handleSubmit, change, data, handleClose }) {

  const { period } = fieldsProps;
  const [status, setStatus] = useState('ACTIVE');
  const { values } = useSelector((state) => state.form.formSettingManualTransaction);

  const {
    isLoadingSubmitAutoApprove
  } = useSelector((s) => s.manualLoggingActivation);

  useEffect(() => {
    change('period', '');
    setStatus(data.status === 'ACTIVE' ? true : false);
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    const params = {
      regional: data.regionalId,
      villageId: [data.villageId],
      activePeriod: values.period,
      status: status ? 'ACTIVE' : 'NON_ACTIVE'
    };
    handleSubmit(params, data.villageName);
  };

  return (
    <form className={styles.form} encType="multipart/form-data" onSubmit={onSubmit}>
      <Field
        component={Select}
        data={period.data}
        inputProps={period}
        name={period.name}
        required={true}
      />
      <br />
      <label>Status</label><span className={styles.isRequired} />
      <Switch
        checked={status}
        color="green"
        labelPosition={'left'}
        offLabel={'Tidak Aktif'}
        onClick={() => setStatus(!status)}
        onLabel={'Aktif'}
        size="lg" />
      <div className={styles.actions}>
        <Button
          //   disabled={isLoadingSubmissionProses}
          onClick={handleClose}
          style="outlined"
          type="button"
        >
          Batal
        </Button>
        <Button
          disabled={values.activePeriod === '' || isLoadingSubmitAutoApprove}
          style={'blue'}
          type="submit"
        >
          Ubah Pengaturan
        </Button>
      </div>
    </form>
  );
}
Component.propTypes = {
  change: PropTypes.func.isRequired,
  data: PropTypes.object,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
};
